import type { AppDropdownOption } from '@/ui/components/AppDropdownSelect';

export type RecipientVisibility = 'private' | 'workspace' | 'personal' | 'organization';
export type UiRecipientVisibility = 'private' | 'workspace';
export type ApiRecipientVisibility = 'private' | 'workspace';

export function normalizeRecipientVisibility(
  value: RecipientVisibility | string | null | undefined,
): 'private' | 'workspace' {
  const raw = (value ?? 'private').toLowerCase();
  if (raw === 'workspace' || raw === 'organization' || raw === 'shared') return 'workspace';
  return 'private';
}

export function visibilityBadgeLabel(value: RecipientVisibility | string | null | undefined): string {
  return normalizeRecipientVisibility(value) === 'workspace' ? 'Workspace' : 'Private';
}

export function getRecipientVisibilityOptions(
  showOrganization: boolean,
): AppDropdownOption[] {
  const options: AppDropdownOption[] = [
    {
      value: 'private',
      label: 'Private',
      description: 'Only you',
      triggerLabel: 'Private — only you',
    },
  ];
  if (showOrganization) {
    options.push({
      value: 'workspace',
      label: 'Workspace',
      description: 'Visible to workspace members',
      triggerLabel: 'Workspace — all members',
    });
  }
  return options;
}

export function resolveRecipientVisibility(
  stored: RecipientVisibility | string | null | undefined,
  isPersonalMode: boolean,
): 'private' | 'workspace' {
  if (isPersonalMode) return 'private';
  return normalizeRecipientVisibility(stored);
}

export function toApiRecipientVisibility(
  value: UiRecipientVisibility | RecipientVisibility | string,
): ApiRecipientVisibility {
  return normalizeRecipientVisibility(value);
}
